import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M26.56 24.928l-3.52-3.488a9.67 9.67 0 002.096-6.032c0-5.373-4.355-9.728-9.728-9.728S5.68 10.035 5.68 15.408a9.73 9.73 0 009.728 9.728 9.7 9.7 0 006.052-2.111l-.02.015 3.488 3.52a1.154 1.154 0 001.632-1.632m-11.136-2.08a7.424 7.424 0 117.424-7.424c0 4.1-3.324 7.424-7.424 7.424" /></svg>;